import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestRevisionSecondView = {
    path: "/revision/second-view",
    method: RouteHttpVerb.GET,
    obfuscatePath: "keep-last-part"
};
